export var ToolbarSize = /*#__PURE__*/function (ToolbarSize) {
  ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
  ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
  ToolbarSize[ToolbarSize["L"] = 4] = "L";
  ToolbarSize[ToolbarSize["M"] = 3] = "M";
  ToolbarSize[ToolbarSize["S"] = 2] = "S";
  ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
  return ToolbarSize;
}({});

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */
export var ToolbarWidths = /*#__PURE__*/function (ToolbarWidths) {
  ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
  ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
  ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
  ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
  ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
  return ToolbarWidths;
}({});
export var ToolbarWidthsNext = /*#__PURE__*/function (ToolbarWidthsNext) {
  ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
  ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
  ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
  ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
  ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
  return ToolbarWidthsNext;
}({});

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */
export var ToolbarWidthsFullPage = /*#__PURE__*/function (ToolbarWidthsFullPage) {
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
  return ToolbarWidthsFullPage;
}({});
export var ToolbarWidthsFullPageNext = /*#__PURE__*/function (ToolbarWidthsFullPageNext) {
  ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
  ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
  ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
  ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
  ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
  return ToolbarWidthsFullPageNext;
}({});